
import { forwardRef } from 'react';
import FormikForm from 'src/ui-component/FormikFormLibrary';
import { Fields } from 'src/ui-component/FormikFormLibrary/FormikTypes';

interface OwnerInfoProps {
  formData: {
    applicantName: string;
    applicantAddress: string;
    applicantSuitePOBox: string;
    applicantCity: string;
    applicantState: string;
    applicantZipCode: string;
    applicantEmail: string;
    applicantPhone: string;
  };
  handleSubmit: (val: any) => void;
  setFieldValue: (field: string, value: any) => void;
  isButtonHide?: boolean;
}

const OwnerInfo = forwardRef<HTMLDivElement, OwnerInfoProps>(
  ({ formData, setFieldValue, isButtonHide , handleSubmit}, ref) => {
  const handleFieldChange = (val: any, e: any) => {
    const { name } = e;
    setFieldValue(name, val);
  };

  const fields: Fields[] = [
    {
      fieldName: 'applicantName',
      initialValue: formData.applicantName,
      fieldLabel: 'Name of Owner/Corporation',
      fieldType: 'text',
      required: true,
      dependency: handleFieldChange
    },
    {
      fieldName: 'applicantAddress',
      initialValue: formData.applicantAddress,
      fieldLabel: 'Address',
      fieldType: 'text',
      required: true,
      dependency: handleFieldChange
    },
    {
      fieldName: 'applicantSuitePOBox',
      initialValue: formData.applicantSuitePOBox,
      fieldLabel: 'Suite/P.O. Box',
      fieldType: 'text',
      required: false,
      dependency: handleFieldChange
    },
    {
      fieldName: 'applicantCity',
      initialValue: formData.applicantCity,
      fieldLabel: 'City',
      fieldType: 'text',
      required: true,
      dependency: handleFieldChange
    },
    {
      fieldName: 'applicantState',
      initialValue: formData.applicantState,
      fieldLabel: 'State',
      fieldType: 'text',
      required: true,
      dependency: handleFieldChange
    },
    {
      fieldName: 'applicantZipCode',
      initialValue: formData.applicantZipCode,
      fieldLabel: 'Zip Code',
      fieldType: 'number',
      required: true,
      dependency: handleFieldChange
    },
    {
      fieldName: 'applicantEmail',
      initialValue: formData.applicantEmail,
      fieldLabel: 'Email',
      fieldType: 'email',
      required: true,
      dependency: handleFieldChange
    },
    {
      fieldName: 'applicantPhone',
      initialValue: formData.applicantPhone,
      fieldLabel: 'Phone Number',
      fieldType: 'mobile',
      required: true,
      dependency: handleFieldChange
    }
  ];

  return (
    <FormikForm
      innerRef ={ref}
      allFields={fields}
      formMethod={handleSubmit}
      heading="Owner Information"
      buttonTitle={['Cancel']}
      buttonPlacement="right"
      content={<></>}
      isButtonHide={isButtonHide}
    />
  );
}
);
OwnerInfo.displayName = 'OwnerInfo';

export default OwnerInfo;